import script from "./Points.vue?vue&type=script&setup=true&lang=js"
export * from "./Points.vue?vue&type=script&setup=true&lang=js"

import "./Points.vue?vue&type=style&index=0&id=1f498fa4&lang=scss&scoped=true"
import "./Points.vue?vue&type=style&index=1&id=1f498fa4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f498fa4"]])

export default __exports__